import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../Components/Button/Button";
import TextField from "../../Components/TextField/TextField";
import { useToast } from "../../Contexts/ToastContext/ToastContext";
import { useAuth } from "../../Contexts/AuthContext/AuthContext";
import "./Login.css";

const Login = () => {
    const navigate = useNavigate();
    const { showToast } = useToast();
    const { login, isOperator } = useAuth();
    const [credentials, setCredentials] = useState({
        username: "",
        password: "",
    });
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        if (!credentials.username || !credentials.password) {
            showToast("Please fill in all fields", 2000, true, "danger");
            return;
        }

        setLoading(true);
        try {
            const response = await login(credentials.username, credentials.password);
            showToast("Login successful", 2000, true, "success");
            const dest = response.user?.role === "operator"
                ? "/operators"
                : response.user?.role === "cashier"
                    ? "/cashier"
                    : "/dashboard";
            setTimeout(() => {
                navigate(dest);
            }, 500);
        } catch (error) {
            console.error("Login error:", error);
            showToast(error.message || "Invalid credentials", 2000, true, "danger");
        } finally {
            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <div className="login-header">
                    <div className="login-logo">
                        <img src="/images/LogoOnly.svg" alt="RFID Inventory System" />
                    </div>
                    <h1 className="login-title">RFID Inventory System</h1>
                    <p className="login-subtitle">Inventory Management</p>
                </div>

                <div className="login-form">
                    <div className="login-field">
                        <TextField
                            label="Username"
                            type="text"
                            placeholder="Enter your username"
                            value={credentials.username}
                            onChange={(e) =>
                                setCredentials({ ...credentials, username: e.target.value })
                            }
                            onKeyPress={handleKeyPress}
                            iconLeft="fa-user"
                        />
                    </div>

                    <div className="login-field">
                        <TextField
                            label="Password"
                            type="password"
                            placeholder="Enter your password"
                            value={credentials.password}
                            onChange={(e) =>
                                setCredentials({ ...credentials, password: e.target.value })
                            }
                            onKeyPress={handleKeyPress}
                            iconLeft="fa-lock"
                        />
                    </div>

                    <div className="login-button">
                        <Button
                            value={loading ? "Signing in..." : "Sign in"}
                            onClick={handleLogin}
                            loading={loading}
                            disabled={loading}
                            variant="primary"
                            width="100%"
                        />
                    </div>
                </div>

                <div className="login-footer">
                    <p className="login-footer-text">Default: admin / admin</p>
                </div>
            </div>
        </div>
    );
};

export default Login;
